var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPrint48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9995 19.8984H6V34.968H41.9995V19.8984Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0229 9.01465H32.4552L37.8133 14.4564V19.8982H11.0229V9.01465Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8133 29.9448H11.0229V39.9912H37.8133V29.9448Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5621 9.20555L37.6228 14.2662C37.6664 14.3098 37.6664 14.3805 37.6228 14.4241C37.6019 14.445 37.5735 14.4568 37.5439 14.4568H32.3716V9.28448C32.3716 9.22283 32.4216 9.17285 32.4832 9.17285C32.5128 9.17285 32.5412 9.18461 32.5621 9.20555Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPrint48);
export default __webpack_public_path__ + "static/media/pictogramBeaconPrint48.2ce232b5f935c53a9ea03f3476bf98de.svg";
export { ForwardRef as ReactComponent };